import { render, staticRenderFns } from "./wxuser.vue?vue&type=template&id=a9e8a074&"
import script from "./wxuser.vue?vue&type=script&lang=js&"
export * from "./wxuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports